import React, { Component } from 'react';
import classes from './guest2.css';
import { connect } from "react-redux";

class Guest2 extends React.Component {

 state = {
   chat: '',
   sendChat: ''
 }

 sendtxt = (evnt) => {
   this.setState({chat:evnt.target.value})
 }

 clk = () => {
   var pingChat = this.state.chat;
   this.props.dispatch({type:"PING_GUEST2",pingChat });
   this.setState({chat:''}) 
 }


 render() {

let chatSec = null;

  console.log('this.props.data[this.props.selIndex].guest2');
  console.log(this.props.data[this.props.selIndex].guest2);

  if (this.props.data[this.props.selIndex].guest2 == undefined) {

    chatSec = (
      <div className={classes.msgBody}>
        <ul className={classes.ulstyle}>
        </ul>
      </div>
    )
  } else {

    console.log('Inside else')
   chatSec = (

     <div className={classes.msgBody}>

      {this.props.data[this.props.selIndex].guest2.map((item,index) => (
       <ul key={index} className={classes.ulstyle}>
        {item}
       </ul>
     ))}

     </div>
 );
}
  
  return (

   <div className={classes.body}>
     <p className={classes.title}>Guest-2</p>
       {chatSec}
     <input type="text" className={classes.inputbox} onChange={this.sendtxt} value={this.state.chat} />
     <button className={classes.btn} onClick={this.clk} >Send</button>
    </div>

   );
  }
}

const mapStateToProps = state => {
    console.log('Inside mapstatetoprops of guset2');
    return {
    data: state.data,
    selIndex:state.selIndex,
     switchuser:state.switchuser
  };
};

export default connect(
  mapStateToProps
)(Guest2);
